<template>
  <div>
    <div>
      <v-form @submit.prevent ref="form" v-model="valid">
        <v-row class="d-flex align-end">
          <v-col cols="12">
            <slot></slot>
          </v-col>
          <v-col cols="12">
            <v-text-field
              class="ma-0"
              label=""
              v-model.trim="item"
              :rules="titleRules"
              color="green"
              type="text"
              :id="`${title}-title`"
              required
              :hide-details="true"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="d-flex flex-row">
            <div v-if="editMode">
              <v-btn
                :class="color"
                class="green align-self-end mr-2"
                @click="updateItem"
                >Update</v-btn
              >
              <v-btn
                :class="color"
                class="green lighten-3 align-self-end"
                @click="cancelItem"
                light
                >Cancel</v-btn
              >
            </div>
            <div v-else>
              <v-btn
                :disabled="!this.item"
                :class="color"
                class="green align-self-end"
                @click="addItem"
                >Add</v-btn
              >
            </div>
          </v-col>
          <v-col cols="12">
            <draggable class="inner" :list="items" group="notes">
              <div
                class="ma-1"
                v-for="(tag, index) in items"
                :key="index"
                :class="{ disabled: editMode, color }"
              >
                <span class="pr-2 cursor--order body-1 green--text darken-2">
                  {{ tag }}
                </span>

                <v-icon small @click="editItem(index)" class="mr-2"
                  >mdi-pencil</v-icon
                >
                <v-icon small @click="removeItem(index)">mdi-close</v-icon>
              </div>
            </draggable>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "SubItems",
  props: {
    title: String,
    subtitle: String,
    color: String,
    value: Array,
    fullHeight: Boolean,
  },
  components: {
    draggable,
  },
  data() {
    return {
      items: this.value,
      valid: true,
      item: "",
      titleRules: [(v) => !!v || "Title is required"],
      editMode: false,
      editIndex: 0,
    };
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.items = val;
    },
  },
  methods: {
    addItem() {
      this.validate();
      if (this.valid) {
        this.items.push(this.item);
        this.item = "";
        this.resetValidation();
      }
    },
    editItem(index) {
      this.editMode = true;
      this.editIndex = index;
      this.item = this.items[index];
    },
    updateItem() {
      this.$set(this.items, this.editIndex, this.item);
      this.editMode = false;
      this.editIndex = 0;
      this.item = "";
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    cancelItem() {
      this.item = "";
      this.editMode = false;
      this.editIndex = 0;
    },
    validate() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
